import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { DateTimeFormat } from '@core/models/date-time-format';
import { LanguageService } from '@core/services/language.service';
import { SUPPORTED_LANGUAGES } from '@core/settings/language.settings';
import { Subscription } from 'rxjs';

@Component({
  selector: 'a18-date-box',
  templateUrl: './a18-date-box.component.html',
  //styleUrl: './a18-date-box.component.scss'
})
export class A18DateBoxComponent implements OnInit, OnDestroy {
  @Input() dateBox!: DateTimeFormat;
  @Input() placeholder!: string;
  @Input() required!: boolean; // act as ng-required
  @Input() selectedDate!: string; // act as ng-model

  @Input() dateFormat!: string;
  @Input() customClass!: string; // act as ng-class
  
  @Output() onChange = new EventEmitter<string>();

  language: string |undefined = SUPPORTED_LANGUAGES.en;
  datePickerSettings: any = {};

  private language$: Subscription = new Subscription();

  constructor(
    private _languageService: LanguageService,
    private _dateAdapter: DateAdapter<any>,
  ) { }

  ngOnInit() {
    // subscribe to object registered in related service
    this.language$ = this._languageService.language$.subscribe((language) => {
      this.language = language;
      this._dateAdapter.setLocale(this.language);
      console.log('Language changed to: ', this.language);
    });
  }
  ngOnDestroy() {
    this.language$.unsubscribe();
  }
}
